import { v2 } from "../../lib/api-v2";
import type { CartSummary } from "./types";

/**
 * Cart REST calls, through the shared v2 client. Every call acts on the signed-in
 * account's cart and returns it as it now stands.
 */

const item = (productId: string) => `/cart/items/${encodeURIComponent(productId)}`;

export const getCart = () => v2.get<CartSummary>("/cart");

/** Adding to a cart that is at checkout unlocks it. */
export const addToCart = (productId: string, quantity = 1) =>
  v2.post<CartSummary>("/cart/items", { product_id: productId, quantity });

export const updateCartQuantity = (productId: string, quantity: number) =>
  v2.patch<CartSummary>(item(productId), { quantity });

/** A credits plan for an amount (rupees, excl. GST); it replaces any other item on the cart. */
export const addPlanToCart = (productId: string, amount: number) =>
  v2.post<CartSummary>("/cart/items", { product_id: productId, amount });

export const updatePlanAmount = (productId: string, amount: number) =>
  v2.patch<CartSummary>(item(productId), { amount });

export const removeFromCart = (productId: string) => v2.delete<CartSummary>(item(productId));

/** Locks the cart for payment and returns it with its total. */
export const checkoutCart = () => v2.post<CartSummary>("/cart/checkout");

/** Goes back from checkout: unlocks the cart, keeping its items. */
export const reopenCart = () => v2.post<CartSummary>("/cart/reopen");
